import React from 'react';
import PropTypes from 'prop-types';

const ageArr = ['20歲以下', '20-29歲', '30-39歲', '40-49歲', '50-59歲', '60歲以上'];

const RegisterAge = (props) => {
  const { age } = props;
  return (
    <div className="field is-horizontal">
      <div className="field-label is-medium">
        <label className="label">購買人年齡</label>
      </div>
      <div className="field-body">
        <div className="field">
          <div className="control">
            <div className="select">
              <select
                className="age"
                value={age}
                onChange={(e) => {
                  props.handleChange(e.target.value, 'age');
                }}
              >
                {ageArr.map(elem => (
                  <option key={`age-${elem}`} value={elem}>
                    {elem}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

RegisterAge.propTypes = {
  handleChange: PropTypes.func.isRequired,
};

export default RegisterAge;



// WEBPACK FOOTER //
// ./src/components/RegisterAge.js